import React from 'react';
import { motion } from 'framer-motion';
export function AboutHero() {
  return <section className="relative h-[70vh] min-h-[600px] w-full overflow-hidden bg-black" data-id="element-25">
      {/* Background Image */}
      <div className="absolute inset-0 bg-cover bg-no-repeat animate-[zoom_20s_infinite_alternate] md:bg-center" style={{
      backgroundImage: "url('https://cdn.magicpatterns.com/uploads/gxrypCZmNztXPTFGdvV8d5/vivek-wardhan.jpg')",
      backgroundPosition: '65% 30%',
      transform: 'scale(1.1)'
    }} data-id="element-26">
        {/* Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/60 to-black/30" data-id="element-27" />
      </div>

      {/* Content */}
      <div className="relative h-full max-w-7xl mx-auto px-6 flex flex-col justify-end pb-24 md:pb-32" data-id="element-28">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="max-w-4xl" data-id="element-29">
          <span className="text-[#c9a961] text-[15px] font-bold tracking-[0.2em] uppercase mb-6 block" data-id="element-30">
            Our Journey
          </span>
          <h1 className="font-display text-white text-[56px] md:text-[80px] font-medium leading-[1.05] tracking-tight mb-8" data-id="element-31">
            A Legacy of Excellence
          </h1>
          <div className="w-24 h-[1px] bg-[#c9a961] mb-8" data-id="element-32" />
          <p className="text-white/90 text-[20px] md:text-[24px] font-light leading-relaxed max-w-3xl" data-id="element-33">
            Discover the journey of BV Group Hospitality and our unwavering
            commitment to exceptional dining experiences.
          </p>
        </motion.div>
      </div>
    </section>;
}